import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CompareHeader,
  CompareTable,
  CompareWrap,
  MatrixArrow,
  MatrixCenter,
  MatrixCollapse,
  MatrixToggleBtn,
  Tick,
} from './styled';

const CellTick = () => <Tick>✓</Tick>;

export const FeatureMatrix = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <CompareWrap>
      <MatrixCenter>
        <MatrixToggleBtn type="button" onClick={() => setOpen((o) => !o)}>
          <MatrixArrow $open={open}>▼</MatrixArrow>
          {open ? t('changePlan.matrix.hide') : t('changePlan.matrix.show')}
        </MatrixToggleBtn>
      </MatrixCenter>

      <MatrixCollapse $open={open}>
        <CompareHeader>
          <h2>{t('changePlan.matrix.title')}</h2>
          <p>{t('changePlan.matrix.subtitle')}</p>
        </CompareHeader>
        <CompareTable>
          <thead>
            <tr>
              <th style={{ width: '36%' }}>{t('changePlan.matrix.feature')}</th>
              <th>{t('changePlan.matrix.pro')}</th>
              <th className="hl">{t('changePlan.matrix.premium')}</th>
              <th>{t('changePlan.matrix.enterprise')}</th>
            </tr>
          </thead>
          <tbody>
            <tr className="cat">
              <td colSpan={4}>{t('changePlan.matrix.catStructure')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowMembers')}</td>
              <td>{t('changePlan.matrix.rowMembersPro')}</td>
              <td className="hl">{t('changePlan.matrix.rowMembersPrem')}</td>
              <td>{t('changePlan.matrix.rowMembersEnt')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowCommunities')}</td>
              <td>1</td>
              <td className="hl">
                {t('changePlan.matrix.rowCommunitiesPrem')}
              </td>
              <td>{t('changePlan.matrix.custom')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowMainCal')}</td>
              <td>{t('changePlan.matrix.rowMainCalPro')}</td>
              <td className="hl">{t('changePlan.matrix.rowMainCalPrem')}</td>
              <td>{t('changePlan.matrix.custom')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowSchedulers')}</td>
              <td>20</td>
              <td className="hl">{t('changePlan.matrix.rowSchedulersPrem')}</td>
              <td>{t('changePlan.matrix.custom')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowStorage')}</td>
              <td>2 GB</td>
              <td className="hl">{t('changePlan.matrix.rowStoragePrem')}</td>
              <td>{t('changePlan.matrix.custom')}</td>
            </tr>

            <tr className="cat">
              <td colSpan={4}>{t('changePlan.matrix.catScheduling')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowSharedCal')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowGroupEvents')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowAttendance')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowTemplates')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowReminders')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>

            <tr className="cat">
              <td colSpan={4}>{t('changePlan.matrix.catComm')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowChat')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowPush')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowApps')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>

            <tr className="cat">
              <td colSpan={4}>{t('changePlan.matrix.catAdmin')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowMemberRoles')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowFiles')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowRegistration')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowAutomations')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowAnalytics')}</td>
              <td>
                <CellTick />
              </td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowTransfer')}</td>
              <td>{t('changePlan.matrix.rowTransferPro')}</td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>

            <tr className="cat">
              <td colSpan={4}>{t('changePlan.matrix.catArch')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowPlanStructure')}</td>
              <td>{t('changePlan.matrix.rowPlanStructurePro')}</td>
              <td className="hl">
                {t('changePlan.matrix.rowPlanStructurePrem')}
              </td>
              <td>{t('changePlan.matrix.rowPlanStructureEnt')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowSettingsPer')}</td>
              <td>{t('changePlan.matrix.rowSettingsPerPro')}</td>
              <td className="hl">
                {t('changePlan.matrix.rowSettingsPerPrem')}
              </td>
              <td>{t('changePlan.matrix.rowSettingsPerEnt')}</td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowCentralized')}</td>
              <td>-</td>
              <td className="hl">
                <CellTick />
              </td>
              <td>
                <CellTick />
              </td>
            </tr>
            <tr>
              <td>{t('changePlan.matrix.rowSuccessMgr')}</td>
              <td>-</td>
              <td className="hl">-</td>
              <td>
                <CellTick />
              </td>
            </tr>
          </tbody>
        </CompareTable>
      </MatrixCollapse>
    </CompareWrap>
  );
};
